import {WebStorageStateStore } from 'oidc-client-ts';
const isBrowser = typeof window !== "undefined";
const oidcConfig =  {
        authority: process.env.KEY_CLOCK_AUTHORITY,
        client_id: process.env.KEY_CLOCK_client_ID,
        redirect_uri: process.env.GATSBY_KEY_CLOCK_REDIRECT_URL,
        post_logout_redirect_uri: process.env.GATSBY_KEY_CLOCK_REDIRECT_LOGOUT_URL,
        response_type: 'code',
        scope: 'openid profile email',
        userStore: isBrowser ? new WebStorageStateStore({ store: window.localStorage }) : undefined,
        automaticSilentRenew: true,
        silent_redirect_uri: process.env.GATSBY_KEY_CLOCK_SILENT_REDIRECT_URL
    };

export default oidcConfig;